import Chart from "react-apexcharts";

import React from "react";

const ChartCI = ({ niz, i }) => {
  const colors = {
    Позоришта: "#d11b43",
    "Музеји и галерије са фондом ": "#46ed24",
    Библиотеке: "#4287f5",
    Биоскопи: "#FFA500",
  };
  const colorArray = i.map((value) => colors[value]);
  return (
    <Chart
      className="chart-content"
      type="bar"
      height={300}
      width={900}
      series={[
        {
          name: "",
          data: niz,
        },
      ]}
      options={{
        tooltip: {
          enabled: true,
          formatter: "",
        },
        xaxis: {
          categories: i,
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return Math.round(value);
            },
          },
        },
        chart: {
          height: 200,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            vertical: true,
            barHeight: "85%",
          },
        },
        dataLabels: {
          enabled: false,
        },

        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                width: 320,
                height: 480,
              },
              xaxis: {
                categories: i,
              },
              plotOptions: {
                bar: {
                  vertical: false,
                },
              },
            },
          },
          {
            breakpoint: 768,
            options: {
              chart: {
                width: 450,
                height: 240,
              },
              xaxis: {
                categories: i,
              },
              plotOptions: {
                bar: {
                  vertical: false,
                },
              },
            },
          },
          {
            breakpoint: 1024,
            options: {
              chart: {
                width: 650,
                height: 240,
              },
              xaxis: {
                categories: i,
              },
              plotOptions: {
                bar: {
                  vertical: false,
                },
              },
            },
          },
        ],

        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },

        colors: colorArray,
      }}
    ></Chart>
  );
};

export default ChartCI;
